import React from "react"
import PropTypes from "prop-types"
import ExploreMore from "components/ExploreMore"
import CrossLinks from "components/Crosslinking"

const FooterLinkBlock = ({ type, entries }) => {
  return null
  // switch (type) {
  //   case "exploreMore":
  //     return <ExploreMore id="footer-links" links={entries} />
  //   case "crosslinks":
  //     return <CrossLinks id="footer-links" links={entries} />
  // }
}

export default FooterLinkBlock

FooterLinkBlock.propTypes = {
  type: PropTypes.string.isRequired,
  entries: PropTypes.array.isRequired,
}
